import { render, staticRenderFns } from "./ImageResize.vue?vue&type=template&id=5c9bf0ed"
import script from "./ImageResize.vue?vue&type=script&lang=js"
export * from "./ImageResize.vue?vue&type=script&lang=js"
import style0 from "./ImageResize.vue?vue&type=style&index=0&id=5c9bf0ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports